import React, { useState } from 'react';
import moment from 'moment';
import { useMediaQuery } from 'react-responsive';

import DatePicker from '../../components/DatePicker/DatePicker';

const API_DATE_FORMAT = 'YYYY-MM-DD';

const searchUrl = new URL(drupalSettings.event_search_page);

/**
 * Component to open the event search page with
 * start date and end date set.
 */
const EventSearchCompact = () => {
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 920px)' });

  function selectTomorrow() {
    setStartDate(moment().add(1, 'days'));
    setEndDate(moment().add(1, 'days'));
  }

  function search() {
    if (startDate && endDate) {
      searchUrl.searchParams.set(
        'startDate',
        startDate ? moment(startDate).format(API_DATE_FORMAT) : '',
      );
      searchUrl.searchParams.set(
        'endDate',
        endDate ? moment(endDate).format(API_DATE_FORMAT) : '',
      );
    } else {
      searchUrl.searchParams.delete('startDate');
      searchUrl.searchParams.delete('endDate');
    }

    window.open(searchUrl);
  }

  return (
    <div className="eventsearch__compact">
      <div className="eventsearch__form">
        <div className="eventsearch__form__filter-wrapper">
          <div className="eventsearch__form__date-wrapper">
            <DatePicker
              startDate={startDate}
              endDate={endDate}
              startDateId={'ruka_start_date'}
              endDateId={'ruka_end_date'}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              allowOneSingleDaySelect={true}
              useMoment={true}
            />
          </div>
        </div>
        {!isTabletOrMobile && (
          <div className="eventsearch__form__date-button-wrapper">
            <button
              onClick={() => selectTomorrow()}
              className="button button--large-full-width"
            >
              {Drupal.t('Tomorrow')}
            </button>
          </div>
        )}
        <div className="eventsearch__form__search-button-wrapper">
          <button onClick={search} className="button button--large-full-width">
            {Drupal.t('Search events')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventSearchCompact;
